
import './Accordion.css';
import AccordionItemRich from './AccordionItemRich';
import AccordionCategory from './AccordionCategory';
import AccordionEventItem from './AccordionEventItem';
import AccordionContactUsItem from './AccordionContactUsItem';
//import AccordionDistrictItem from './AccordionDistrictItem';
import React from "react";
import ReactDOM from "react-dom";

class AccordionItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false,closeAll:false, openItem:0 };
    this.toggleItem = this.toggleItem.bind(this);
  }
  
  componentDidMount(){
    if(this.props.openItem && this.props.openItem == this.props.data.ID){
      this.setState(
          {  
            isOpen: true,
            openItem: this.props.openItem
          }
      )
    }
  }

  toggleItem(event){
    event.preventDefault();
    this.setState({ isOpen : !this.state.isOpen, openItem:0 });
  } 
  render() {
    var accItem = null;
    let isUrlEvent = this.props.data.ID == this.props.openItem;
    if(this.props.type == "ContactUs"){
      accItem = <AccordionContactUsItem data={this.props.data}
      Title={this.props.Title}
      WpId={this.props.WpId}
      index={this.props.index}
      isOpen={this.state.isOpen}
      toggleItem={this.toggleItem}
      type={this.props.type}
      layout={this.props.layout}
      handleUserKeypress = {this.props.handleUserKeypress}
      />
    }
    else if(this.props.type == "Form"){
      accItem = <AccordionCategory items={this.props.data}
      Title={this.props.Title}
      WpId={this.props.WpId}
      index={this.props.index}
      isOpen={this.state.isOpen}
      toggleItem={this.toggleItem}
      type={this.props.type}
      layout={this.props.layout}
      handleUserKeypress = {this.props.handleUserKeypress}
     />
    }
    else if(this.props.type == "Event"){
      accItem = <AccordionEventItem data={this.props.data}
      WpId={this.props.WpId}
      index={this.props.data.ID}
      openItem={this.state.openItem}
      isOpen={this.state.isOpen }
      toggleItem={this.toggleItem}
      type={this.props.type}
      handleUserKeypress = {this.props.handleUserKeypress}
      />
    }
    else if(this.props.layout ===  "first"){ //news
      accItem = <AccordionItemRich data={this.props.data}
      WpId={this.props.WpId}
      index={this.props.index}
      isOpen={this.state.isOpen}
      toggleItem={this.toggleItem}
      type={this.props.type}
      handleUserKeypress = {this.props.handleUserKeypress}/>
      
    }
    else if(this.props.layout ===  "second"){
      accItem = <AccordionCategory items={this.props.data}
      Title={this.props.Title}
      WpId={this.props.WpId}
      index={this.props.index}
      isOpen={this.state.isOpen}
      toggleItem={this.toggleItem}
      type={this.props.type}
      handleUserKeypress = {this.props.handleUserKeypress}/>
    }
    return (
      <React.Fragment>{accItem}</React.Fragment>
      
    );
  }
 }
export default AccordionItem;


